export default __webpack_public_path__ + "static/media/istockphoto-1225830150-612x612.6841d5ab.jpg";